// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

// LanguageBadge — the patient's language next to their name on every CareRx screen (ASP ticket #9,
// widened 2026-10-07: always shown, English included). The server decides the name
// (PreferredLanguage.cs); null means Pioneer gave no usable language, shown as "—" with a tooltip.
// undefined means "not known yet" (still loading, or the row carries no language) and renders nothing,
// so a badge never flashes "—" before the data arrives.
// Shared in components/ui because every CareRx list shows it (E-01). Token-styled until the MUI ADR.

/** The response redactor masks the flag for roles that may not see PHI (FieldRedactor: "••••••"). */
const isMasked = (v: string) => /^[•*]+$/.test(v.trim())

export const NOT_DETECTED_TITLE = 'Did not detect language from Pioneer'

const base = {
  display: 'inline-block', marginLeft: 6, padding: '1px 7px', borderRadius: 10, fontSize: 10.5,
  fontWeight: 600, whiteSpace: 'nowrap', verticalAlign: 'middle',
} as const

export default function LanguageBadge({ language }: { language?: string | null }) {
  if (language === undefined) return null
  if (language !== null && isMasked(language)) return null
  const name = language?.trim()
  if (!name) {
    return (
      <span title={NOT_DETECTED_TITLE} aria-label={NOT_DETECTED_TITLE}
        style={{ ...base, background: 'transparent', color: 'var(--color-text-muted, #8496a5)',
          border: '1px dashed var(--color-border, #cbd5e1)' }}>
        —
      </span>
    )
  }
  const english = name.toLowerCase() === 'english'
  return (
    <span title={`Preferred language: ${name}`} aria-label={`Preferred language ${name}`}
      style={english
        ? { ...base, background: 'var(--color-surface-alt, #eef2f6)', color: 'var(--color-text-soft, #475569)' }
        : { ...base, background: 'var(--color-warning-bg, #fef3c7)', color: 'var(--color-warning-fg, #92400e)' }}>
      {name}
    </span>
  )
}
